import React, {useContext, useEffect, useMemo, useState} from 'react'
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";
import useTranslate from "../../../modules/local/useTranslate";
import {LoginContext} from "../../../components/LoginContext";
import {Switch} from "antd";
import {godwords_getSuggestedWords_Api, godwordsSchema} from "../../../apis/godwords";
import _ from "lodash"
import CRUD from "../../Shared/enums/CRUD";
import {NullAsDefault, renderIfElse} from "../../Shared";
import {getGodWordDisplayConfigKey, setGodWordDisplayConfigKey} from "../../../helpers/localStorage";
import ResponsiveTextLabel from "../../../components/ResponsiveTextLabel/ResponsiveTextLabel";
import {MdOutlineToggleOff, MdToggleOn} from "react-icons/md";
import {Link} from "react-router-dom";
import {useHistory} from "../../../modules/navigation/useRouter";
import {getRouteSearchParams, useRouteSearchParam} from "../../../envs/_current/history";
import {useGodWords} from "./functions/useGodWords";
import {SelectEntityItem} from "../../../components/SelectEntityItem";
import {getId} from "../../../apis/model/base";
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {GodWordsDialog} from "./containers/WordOfGodDialog";
import Modal from "../../../components/Modal/Modal";
import {DelayRender} from "../../Shared/components/DelayRender";
import {ViewMeditation} from "../Codi/CalendarLiturgicalTextForm";
import {LocalContext} from "../../../modules/local/LocalContext";
import {addElementToStackArray} from "../../../helpers/addElementToStackArray";
import {FaBackward, FaForward} from "react-icons/fa6";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import TooltipApp from "../../../components/TooltipApp";
import {getLinkToDetailRow} from "../Codi/codiHelpers";
import LoadingBlock from "../../Loading/LoadingBlock";
import {PiHeart, PiHeartFill} from "react-icons/pi";
import {useRequiredLogin} from "../../Server/useRequiredLogin";

const WogComponent = ({children, defaultId, today = 0, ...props}) => {

    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const history = useHistory()
    const login = useContext(LoginContext)
    const displayConfig = getGodWordDisplayConfigKey();
    const [isLatestBookmark, setLatestBookmark] = useState(Number(displayConfig) === 1)
    const [action, setAction] = useState({type: undefined, value: undefined})
    const {timezone_offset_in_hours} = useContext(LocalContext)
    const [list, setList] = useState([])
    const [selectedItem, setSelectedItem] = useState()
    const handleRequiredLogin = useRequiredLogin()

    const onCancel = () => {
        const params = getRouteSearchParams()
        params.delete('popup')
        history.replace({
            search: params.toString(),
        })
        setAction({})
    }

    const onBack = () => {
        setSelectedItem(prevSelectedItem => {
            return _.cloneDeep(_.first(list));
        });
        let _list = _.cloneDeep(list);
        _list.shift();
        setList(prevList => {
            return _list;
        });

    };

    const popup = useRouteSearchParam('popup')

    // onSuccess không tự set selectedItem nữa — useEffect [isLatestBookmark, defaultId, item, data]
    // bên dưới đã derive lại y hệt giá trị này ngay khi response đổi, gọi setSelectedItem 2 lần liên
    // tiếp (1 lần ở đây, 1 lần ở effect) gây render lại thừa lúc load xong (yêu cầu giảm render).
    const {response, isLoading = true, handleAsyncAction: fetchRandomGodWords} = useAsyncAction({
        apiInfo: godwords_getSuggestedWords_Api,
    })

    useEffect(() => {
        if (!!!action.type && popup === 'divine-word') {
            setAction({type: CRUD.READ, value: {}});
        }
        let inputParam = {limit: 1, timezone_offset_in_hours}
        if (defaultId) inputParam.id = defaultId
        if (today) inputParam.today = 1;
        fetchRandomGodWords(
            {...inputParam},
            {}
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const item = _.get(response, 'data.item');
    const data = _.get(response, 'data.data', []);

    useEffect(() => {
        if (!_.isEmpty(response) && _.isEmpty(item) && isLatestBookmark) {
            setLatestBookmark(false);
            // setGodWordDisplayConfigKey("0")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLatestBookmark, item])

    useEffect(() => {
        const selectedItem = (isLatestBookmark && !!!defaultId) ? item : _.get(data, '0')
        setSelectedItem(selectedItem)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLatestBookmark, defaultId, item, data])

    const codi_page = _.get(selectedItem, 'codi_document_row') ?? {}

    const modal = useMemo(() => {
        let Content = NullAsDefault
        let params = {}
        let modal_params = {}
        switch (action.type) {
            case CRUD.READ:
                params = {
                    default_id: action.value?.id
                }
                modal_params = {
                    width: 640,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('divine word')}
                        </div>
                    ),
                }
                Content = GodWordsDialog
                break
            case "MEDITATION_VIEWER":
                params = {
                    // item: action.value
                }
                modal_params = {
                    width: 640,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('meditation')}
                        </div>
                    ),
                }
                Content = ViewMeditation
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Content
                        {...{
                            onCancel,
                            item: action.value,
                        }}
                        {...params}
                    />
                </DelayRender>
            </Modal>
        )
    }, [action])

    const {
        onVote, onDevote
    } = useGodWords({
        notifyListeners: {
            onVotedSuccess: (result) => {
                // onRefresh()
            },
            onDevotedSuccess: (result) => {
                // onRefresh()
            },
        },
    })

    const _selectedItem = !!selectedItem
        ? selectedItem
        : ((isLatestBookmark && !!!defaultId) ? item : _.get(data, '0'))

    const minHeight = isSm ? 140 : 179

    if (isLoading) {
        return <LoadingBlock style={{height: minHeight}}/>;
    }

    return (
        <React.Fragment>
            <SelectEntityItem
                item={getId(_selectedItem)}
                schema={godwordsSchema}>
                {(sItem) => {
                    const selItem = !!sItem ? sItem : _selectedItem;

                    return selItem ? (
                        <div className="w-full flex flex-col gap-3">
                            <div className="flex items-center justify-between gap-2">
                                <span
                                    onClick={() => {
                                        setAction({type: CRUD.READ, value: selItem});
                                    }}
                                    className="inline-flex flex-shrink-0 items-center px-3 py-1 rounded-full border border-white-40 text-white text-2xs font-bold uppercase tracking-wider cursor-pointer">
                                    {t('god word today')}
                                </span>
                                <div className="flex items-center gap-2 min-w-0">
                                    {selItem?.source_text && (
                                        <Link
                                            to={getLinkToDetailRow(codi_page) || "#"}
                                            target="_blank"
                                            className="font-bold text-xs text-white no-underline tracking-wide truncate">
                                            {selItem.source_text}
                                        </Link>
                                    )}
                                    {item && (
                                        <TooltipApp
                                            placement="left"
                                            color="white"
                                            title={
                                                <div className="flex flex-col">
                                                <span className="flex items-center gap-2">
                                                    <MdToggleOn className="text-color-100"/>
                                                    <span
                                                        className="text-2xs text-color-100 italic">{t('bookmarked items')}</span>
                                                </span>
                                                    <span className="flex items-center gap-2">
                                                    <MdOutlineToggleOff className="text-color-100"/>
                                                    <span className="text-2xs text-color-100 italic">{t('random')}</span>
                                                </span>
                                                </div>
                                            }>
                                            <Switch
                                                size="small"
                                                checked={isLatestBookmark}
                                                onChange={(checked) => {
                                                    setGodWordDisplayConfigKey(checked ? 1 : 0)
                                                    setLatestBookmark(checked)
                                                }}
                                            />
                                        </TooltipApp>
                                    )}
                                </div>
                            </div>
                            <div style={{minHeight: minHeight}} className="flex flex-center">
                                {selItem?.content ? (
                                    <Link to={getLinkToDetail(selItem)} className="no-underline">
                                        <ResponsiveTextLabel
                                            text={selItem.content}
                                            showIcon={false}
                                            style={{minHeight}}
                                            className="text-white italic"/>
                                    </Link>
                                ) : (
                                    <LoadingBlock style={{height: minHeight}}/>
                                )}
                            </div>
                            <div className="flex items-center justify-center gap-5">
                                <TooltipApp title={t('prev doc')} classNames={{root: "font-medium text-xs italic"}} className="flex flex-center">
                                    <FaBackward
                                        onClick={() => {
                                            if (list.length) {
                                                onBack()
                                            }
                                        }}
                                        size={14}
                                        className={list.length > 0 ? 'text-white opacity-70 hover:opacity-100 cursor-pointer' : 'text-white opacity-25'}
                                    />
                                </TooltipApp>
                                {renderIfElse(
                                    !!selItem?.vote_status,
                                    <PiHeartFill
                                        size={18}
                                        className="flex text-primary hover:text-primary-700 cursor-pointer"
                                        onClick={() => {
                                            handleRequiredLogin(() => {
                                                onDevote({owner_type: 'god_word', owner_id: selItem?.id})
                                            })
                                        }}
                                    />,
                                    <TooltipApp title={t('bookmarked items')}
                                                classNames={{root: "font-medium text-xs italic"}}>
                                        <PiHeart
                                            size={18}
                                            className="flex text-white opacity-80 hover:opacity-100 hover:text-primary cursor-pointer"
                                            onClick={() => {
                                                handleRequiredLogin(() => {
                                                    onVote({owner_type: 'god_word', owner_id: selItem?.id})
                                                })
                                            }}
                                        />
                                    </TooltipApp>
                                )}
                                <TooltipApp title={t('next doc')} classNames={{root: "font-medium text-xs italic"}} className="flex flex-center">
                                    <FaForward
                                        onClick={() => {
                                            const arr = addElementToStackArray(_.cloneDeep(list), _.cloneDeep(selItem), 100);
                                            setList(arr)
                                            fetchRandomGodWords(
                                                {limit: 1, timezone_offset_in_hours, exclude_id: selItem?.id},
                                                {}
                                            )
                                        }}
                                        size={14}
                                        className="text-white opacity-70 hover:opacity-100 cursor-pointer"
                                    />
                                </TooltipApp>
                            </div>
                        </div>
                    ) : (
                        <LoadingBlock style={{height: minHeight}}/>
                    )
                }}
            </SelectEntityItem>
            {modal}
        </React.Fragment>
    )
}

export default WogComponent
